import { render, staticRenderFns } from "./MarketOrderForm.vue?vue&type=template&id=23bdcad7&scoped=true&"
import script from "./MarketOrderForm.vue?vue&type=script&lang=js&"
export * from "./MarketOrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bdcad7",
  null
  
)

export default component.exports